import React, { Component }        from 'react'
import { connect }                 from 'react-redux'
import PropTypes                   from 'prop-types'
import Dependent, { GlobalLoader } from 'containers/shared/Dependent'
import StyleSheet                  from 'styles'
import AddIcon                     from '@material-ui/icons/Add'
import Button                      from '@material-ui/core/Button'
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import List from '@material-ui/core/List';
import Typography                  from '@material-ui/core/Typography'
import { NominationActions, SnackbarActions, AllocationActions } from 'actionsets'
import { Authorization }           from 'utils/AuthorizationUtils'
import NominationDialog            from './NominationDialog'
import { NominationListItem }      from './NominationListItem'
import { Pagination }              from 'components'
import { withRouter }              from 'react-router'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'

export class NominationsList extends Component {

  static propTypes = {
    dealSheet: PropTypes.object.isRequired
  }

  constructor(props){
    super(props)
    this.state = {
      ...this.state,
      newNominationDialog: {
        open: false
      },
      page: 1
    }

    NominationActions.bindActions(this)
    AllocationActions.bindActions(this, 'allocations')
    SnackbarActions.bindActions(this, 'snackbar')
  }

  dependsOn = () => {
    return this.loadNominations()
  }

  loadNominations = async () => {
    await this.actions.index(this.props.dealSheet.id, this.currentPage)
  }

  dependenciesMet = () => {
    return this.props.requests.length === 0
  }

  newNomination = () => {
    this.actions.resetErrors()
    this.setState({newNominationDialog: {...this.state.newNominationDialog, open: true}})
  }

  handleNominationDialogClosed = () => {
    this.setState({newNominationDialog: {open: false}})
  }

  handleNominationAdded = () => {
    this.loadNominations()
  }

  handleNominationDeleted = async (nomination) => {
    const { id } = nomination
    try {
      await this.actions.destroy({ id })
      this.loadNominations()
      this.actions.snackbar.success(`Nomination deleted!`)
    }catch(error) {
      this.actions.snackbar.error('Failed to delete nomination!')
    }
  }

  handleAllocate = ({userId, size}) => {
    this.actions.allocations.setNewInvestorIds({ids: [userId], params: {
      amount: parseFloat(this.props.dealSheet.preSaleRate * size),
      rate: parseFloat(this.props.dealSheet.preSaleRate),
      thirdPartyCommissions: []
    }})
    this.props.history.push(`/deal_sheets/${this.props.dealSheet.id}/allocations/edit`)
  }

  get canAddNomination() {
    return Authorization.issuer && this.props.dealSheet.status !== 'closed'
  }

  set currentPage(page){
    this.setState({ page }, this.loadNominations )
  }

  get currentPage(){
    return Math.min(this.state.page, this.totalPages)
  }

  get totalPages(){
    let totalPages = this.props.totalPages
    return (!!totalPages) ? totalPages : 0
  }

  renderPagination() {
    return(
      <Pagination className={styles.pagination} totalPages={this.totalPages}
        page={this.currentPage}
        onPageSelected={(page) => this.currentPage = page}/>
    )
  }

  renderNominations() {
    const items = this.props.nominations.map((nomination) => {
      const { id } = nomination
      return <NominationListItem key={id} nomination={ nomination } onDeleted={this.handleNominationDeleted} onAllocation={this.handleAllocate}/>
    })

    if(items.length === 0 && !this.canAddNomination) {
      return <Typography className={styles.subheading} ype='subheading'>No nominations have been created yet.</Typography>
    }

    return (
      <List className={styles.list}>
        { items }
      </List>
    )
  }

  renderAddNominationButton() {
    return (
      <Button variant='fab' color='primary' onClick={ this.newNomination } className={styles.addOnTop}>
        <AddIcon />
      </Button>
    )
  }

  render() {
    return (
      <Card raised>
        <AppBar style={{position: 'relative', boxShadow: 'none'}} color='inherit'>
          <Toolbar>
            <Typography className={styles.subheading} variant='h4'>Investor Nominations</Typography>
            { this.canAddNomination && this.renderAddNominationButton() }
          </Toolbar>
        </AppBar>
        <CardContent>
          { this.renderPagination() }
          { this.renderNominations() }
          { this.renderPagination() }
          <NominationDialog
            open={this.state.newNominationDialog.open}
            dealSheet={ this.props.dealSheet }
            onClose={this.handleNominationDialogClosed}
            onNominationAdded={this.handleNominationAdded}
        />
        </CardContent>
      </Card>
    )
  }
}

const styles = StyleSheet({
  wrapper: {
  },
  list: {
    padding: 0
  },
  addOnTop: {
    bottom: '-28px',
    right: '30px',
    zIndex: '100',
    position: 'absolute'
  },
  newNominationDialogTextField: {
    marginTop: '10px',
    marginBottom: '10px'
  },
  newNominationDialogBody: {
    display: 'flex',
    flexDirection: 'column'
  },
  pagination: {
    paddingTop: 20,
  },
})

export default connect(({nominations}) => nominations)(withRouter(Dependent({loader: GlobalLoader, wrapperClassName: styles.wrapper})(NominationsList)))
